// import Project1 from "../images/projects/thumbnail1.jpg";
// import Project2 from "../images/projects/thumbnail2.jpg";
// import Project3 from "../images/projects/thumbnail3.jpg";
// import Project4 from "../images/projects/thumbnail4.jpg";
// import Project5 from "../images/projects/thumbnail5.jpg";
// import Project6 from "../images/projects/thumbnail6.jpg";
import SystemDis from "../images/SystemDis.png";
import WaterS from "../images/WaterS.png";
import Pick from "../images/pick.png";
import Water from "../images/water.png";
// import Ecommerce3 from "../images/projects/ecommerce-3.jpg";
// import Social1 from "../images/projects/social-1.jpg";
// import Portfolio1 from "../images/projects/portfolio-1.jpg";
import ioPick from "../images/projects/ioPick.png";
import ioWater from "../images/projects/ioWater.png";
// import Task2 from "../images/projects/taskmanager-2.jpg";
// import Fitness1 from "../images/projects/fitness-1.jpg";
// import Fitness2 from "../images/projects/fitness-2.jpeg";
// import Track1 from "../images/projects/track-1.jpg";
// import V1 from "../images/projects/videos/Pick_Place.mp4";
// // import V2 from "../images/projects/videos/Water_System.mp4";
// import V3 from "../images/projects/videos/3.mp4";
// import V4 from "../images/projects/videos/4.mp4";
// import V5 from "../images/projects/videos/5.mp4";
// import V6 from "../images/projects/videos/6.mp4";


const projects = [
  {
    id: 1,
    title: "Pick and Place System",
    description:
      "This project simulates an automated pick-and-place system controlled by an Allen-Bradley PLC. The PLC manages the machine cycle, reads sensor inputs, controls conveyor movement, and integrates industrial data with PostgreSQL.",
    thumbnail: Pick, // Path to the thumbnail
    images: [ioPick],
     // Array of additional images—
   video: "https://www.youtube.com/embed/sPyZYca76f8?rel=0&modestbranding=1&playsinline=1",
    git: "", 
    category: "automation",
     technologies: [
    "Allen-Bradley PLC (Logix 5000)",
    "Studio 5000",
    "Ladder Logic",
    "Factory IO",
    "FactoryTalk View",
    "PostgreSQL",
  ],

  architecture: [
    "Factory IO",
    "PLC (Studio 5000)",
    "FactoryTalk View",
    "PostgreSQL",
  ],
  },
 
  {   
    id: 2,
    title: "Automated Water Filtration System",
    description:
      "This project simulates an automated water treatment and filtration system controlled by a PLC. The system monitors tank levels, manages pump operation, and distributes water once the tank reaches 80% capacity. A differential pressure detection mechanism is used to identify filter clogging. When the pressure difference across the filter exceeds a threshold, the PLC automatically triggers a backwash cycle to clean the filter using stored water. The project demonstrates industrial automation concepts including pump control, valve sequencing, pressure monitoring, and automated filtration processes.",
    thumbnail: Water,
    images: [
      WaterS,
      ioWater
    ],
    video: "https://www.youtube.com/embed/XpOeSS1-fPk?rel=0&modestbranding=1&playsinline=1",
    git: "https://github.com/",
    category: "automation", 
  
     technologies: [
    "Allen-Bradley PLC (Logix 500)",
    "Studio 500",
    "Ladder Logic",
    "Wonderware InTouch",
    "SQL",
  ],

  architecture: [
    "PLC (Studio 500)",
    "Wonderware InTouch",
    "SQL",
  ],
  },
   {   
    id: 3,
    title: "Peanut and Walnut Filling System",
    description:
      "This project simulates an automated distribution and filling system for peanuts and walnuts controlled by an Allen-Bradley PLC. A conveyor transports tanks to the filling station, where sensors detect the tank position and stop the conveyor automatically. The system can operate in Auto, Manual, or Mix mode, allowing tanks to be filled with peanuts, walnuts, or a combination of both products. Level control is used to stop the filling process at 80% capacity, and alarms are generated if the level exceeds or does not reach the target. The project demonstrates industrial automation concepts such as conveyor control, sensor integration, automated filling processes, alarm handling, and HMI monitoring.",
    thumbnail: SystemDis,
    images: [
      
    ],
    video: "https://www.youtube.com/embed/bhvMdLkBVQk?rel=0&modestbranding=1&playsinline=1",
    git: "https://github.com/",
    category: "automation", 
  
     technologies: [
    "Allen-Bradley PLC (Logix 500)",
    "Studio 500",
    "Ladder Logic",
    "Wonderware InTouch",
    "SQL",
  ],

  architecture: [
    "PLC (Studio 500)",
    "Wonderware InTouch",
    "SQL",
  ],
  },
 
];

export default projects;

export const WorkNavData = [
  {
    name: "all",
  },
  {
    name: "automation",
  },
  // {
  //   name: "web",
  // },
];
